import {z} from 'zod'

export type TransactionEntryLine = {
    entryUuid: string,
    date: Date,
    description: string,
    amount: number,
    bban?: string,
    accrualAccountNo?: string,
    accrualDuration?: number,
    accrualStartMonth?: number,
    accrualStartYear?: number,
    debitAccount?: string,
    debitSubAccount?: string,
    creditAccount?: string,
    creditSubAccount?: string,
    vatOptionIdDebit: number,
    vatOptionIdCredit: number,
    invoiceNo?: string,
    invoiceUuid?: string,
    invoiceDueDate?: Date,
    project?: string,
    department?: string,
    tags: Array<string>,
    kid?: string,
    subAccountLines: string[],
    paymentDate?: Date,
    entryLineIndex: number,
}

export const TransactionEntryLineSchema = z.object({
    date: z.iso.date().nullish(),
    description: z.string().nullish(),
    amount: z.number().nullish(),
    bban: z.string().nullish(),
    accrualAccountNo: z.string().nullish(),
    accrualDuration: z.number().nullish(),
    accrualStartMonth: z.number().nullish(),
    accrualStartYear: z.number().nullish(),
    debitAccount: z.string().nullish(),
    debitSubAccount: z.string().nullish(),
    creditAccount: z.string().nullish(),
    creditSubAccount: z.string().nullish(),
    vatOptionIdDebit: z.number().nullish(),
    vatOptionIdCredit: z.number().nullish(),
    invoiceNo: z.string().nullish(),
    invoiceUuid: z.string().nullish(),
    invoiceDueDate: z.iso.date().nullish(),
    project: z.string().nullish(),
    department: z.string().nullish(),
    tags: z.array(z.string()),
    kid: z.string().nullish(),
    subAccountLines: z.array(z.uuid()),
    paymentDate: z.date().nullish(),
    entryLineIndex: z.number().nullish(),
})
